<template>
  <modal
    name="pop-beta-modal"
    :adaptive="true"
    :classes="['pop-beta-modal']"
    :height="'auto'"
    :scrollable="true"
    :width="500"
  >
    <button
      class="close-button"
      @click="close"
    >
      <icon
        name="cross-thin"
        class="close-icon"
      />
    </button>
    <p class="modal-title">
      Beta Now, Better Later
    </p>
    <p class="modal-text">
      Our Possibility of Passing feature is a bit too new to stake your future on,
      but its accuracy is improving bit-by-bit each time you and others answer
      questions or let us know you passed the NCLEX.
    </p><p class="modal-text">
      Which is a long way of saying that this feature is a tool for your test prep
      and planning, and it shouldn’t be interpreted as a guarantee from us to you
      that you’re ready for the exam.
    </p>
    <button
      class="accept-button"
      @click="close"
    >
      I Accept
    </button>
    <button
      class="cancel-button"
      @click="close"
    >
      Cancel
    </button>
  </modal>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: { Icon },
  methods: {
    close() {
      this.$modal.hide('pop-beta-modal');
    },
  },
};
</script>

<style lang="scss">
.pop-beta-modal {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 40px;
  position: relative;

  .close-button {
    right: rem-calc(16);
    position: absolute;
    top: rem-calc(16);
    height: rem-calc(28);
    width: rem-calc(28);
    border-radius: 14px;
    background: #efefef;
    border: none;

    .close-icon {
      height: rem-calc(12);
      width: rem-calc(12);
    }
  }

  .modal-title {
    font-weight: $bold;
  }

  .modal-text {
    line-height: 1.33;
  }

  .accept-button,
  .cancel-button {
    border: none;
    border-radius: 24px;
    display: block;
    margin: 0 auto;
  }

  .accept-button {
    padding: 16px 48px;
    text-transform: uppercase;
    background-color: #000000;
    color: #FFFFFF;
    margin-top: 48px;
  }

  .cancel-button {
    background: transparent;
    margin-top: 24px;
  }
}
</style>
